import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Clock, Instagram, Facebook } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-800 text-white" data-id="element-126">
      <div className="container mx-auto px-4 py-12" data-id="element-127">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-128">
          {/* Footer Navigation */}
          <div data-id="element-129">
            <h3 className="text-xl font-semibold mb-4" data-id="element-130">Quick Links</h3>
            <ul className="space-y-2" data-id="element-131">
              <li data-id="element-132">
                <Link to="/" className="hover:text-burgundy-300 transition-colors" data-id="element-133">
                  Home
                </Link>
              </li>
              <li data-id="element-134">
                <Link to="/tips" className="hover:text-burgundy-300 transition-colors" data-id="element-135">
                  Tips
                </Link>
              </li>
              <li data-id="element-136">
                <Link to="/faq" className="hover:text-burgundy-300 transition-colors" data-id="element-137">
                  FAQ
                </Link>
              </li>
              <li data-id="element-138">
                <Link to="/blogs" className="hover:text-burgundy-300 transition-colors" data-id="element-139">
                  Blogs
                </Link>
              </li>
              <li data-id="element-140">
                <Link to="/about" className="hover:text-burgundy-300 transition-colors" data-id="element-141">
                  About Us
                </Link>
              </li>
              <li data-id="element-142">
                <Link to="/contact" className="hover:text-burgundy-300 transition-colors" data-id="element-143">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-144">
                <Link to="/standard-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-145">
                  Standard Lessons
                </Link>
              </li>
              <li data-id="element-146">
                <Link to="/intensive-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-147">
                  Intensive Lessons
                </Link>
              </li>
              <li data-id="element-148">
                <Link to="/additional-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-149">
                  Additional Lessons
                </Link>
              </li>
              <li data-id="element-150">
                <Link to="/total-drive" className="hover:text-burgundy-300 transition-colors" data-id="element-151">
                  Total Drive App
                </Link>
              </li>
            </ul>
          </div>
          {/* Operating Hours */}
          <div data-id="element-152">
            <h3 className="text-xl font-semibold mb-4" data-id="element-153">Operating Hours</h3>
            <ul className="space-y-2" data-id="element-154">
              <li className="flex items-center gap-2" data-id="element-155">
                <Clock size={16} data-id="element-156" />
                <span data-id="element-157">Monday - Thursday: 9:15 AM - 7:00 PM</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-158">
                <Clock size={16} data-id="element-159" />
                <span data-id="element-160">Friday: Closed</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-161">
                <Clock size={16} data-id="element-162" />
                <span data-id="element-163">Saturday - Sunday: 9:15 AM - 7:00 PM</span>
              </li>
            </ul>
          </div>
          {/* Customer Care */}
          <div data-id="element-164">
            <h3 className="text-xl font-semibold mb-4" data-id="element-165">Customer Care</h3>
            <ul className="space-y-2" data-id="element-166">
              <li className="flex items-center gap-2" data-id="element-167">
                <Phone size={16} data-id="element-168" />
                <a href="tel:07481300600" className="hover:text-burgundy-300 transition-colors" data-id="element-169">
                  07481 300 600
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-170">
                <Mail size={16} data-id="element-171" />
                <a href="mailto:info@northamptondrivingschool.co.uk" className="hover:text-burgundy-300 transition-colors" data-id="element-172">
                  info@northamptondrivingschool.co.uk
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-4" data-id="element-173">
              <a href="#" aria-label="Facebook" className="hover:text-burgundy-300 transition-colors" data-id="element-174">
                <Facebook size={20} data-id="element-175" />
              </a>
              <a href="#" aria-label="Instagram" className="hover:text-burgundy-300 transition-colors" data-id="element-176">
                <Instagram size={20} data-id="element-177" />
              </a>
            </div>
          </div>
        </div>
        {/* Created by Bright Pixxel Studio */}
        <div className="mt-8 flex justify-center" data-id="element-178">
          <a href="https://bright-pixxel.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors group" data-id="element-179">
            <span className="text-sm" data-id="element-180">Created by</span>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eufMZCrDQQvvNGVXgGvmTe/Logo_for_Bright_Pixxel_Studio.png" alt="Bright Pixxel Studio Logo" className="h-12 w-auto group-hover:opacity-90 transition-opacity" data-id="element-181" />
            <span className="text-sm font-medium" data-id="element-182">Bright Pixxel Studio</span>
          </a>
        </div>
        <hr className="my-8 border-gray-700" data-id="element-183" />
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-184">
          <div className="text-sm text-gray-400 mb-4 md:mb-0 flex flex-col items-center md:items-start" data-id="element-185">
            <div data-id="element-186">
              <span data-id="element-187">
                <span className="text-burgundy-300" data-id="element-188">N</span>orthampton{' '}
                <span className="text-burgundy-300" data-id="element-189">D</span>riving{' '}
                <span className="text-burgundy-300" data-id="element-190">S</span>chool
              </span>
            </div>
            <div className="mt-2" data-id="element-191">
              &copy; {new Date().getFullYear()} All rights reserved.
            </div>
          </div>
          <div className="flex flex-wrap gap-4 text-sm" data-id="element-192">
            <Link to="/privacy" className="hover:text-burgundy-300 transition-colors" data-id="element-193">
              Privacy & Cookie Policy
            </Link>
            <Link to="/terms" className="hover:text-burgundy-300 transition-colors" data-id="element-194">
              Terms & Conditions
            </Link>
            <Link to="/cancellation" className="hover:text-burgundy-300 transition-colors" data-id="element-195">
              Cancellation, Health & Safety Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;